import React from "react";
import { Alert } from "@mui/material";
import { useAuth } from "hooks/useAuth";

/**
 * CareMap Ads (carousel / zip-slot) desk.
 * On sandbox this is the Fusion Affiliate role. A facility account does not
 * get this desk.
 */
export function ZipSlotAdsGate({ children }) {
  const { userData, isGlobalAdmin } = useAuth();
  const allowed = isGlobalAdmin || userData?.role === "fusionAffiliate";
  if (!allowed) {
    return (
      <Alert severity="warning">
        CareMap Ads is available to the Fusion Affiliate role.
      </Alert>
    );
  }
  return children;
}

export default ZipSlotAdsGate;
